import { Text, Modal, Button } from '@querodelivery/uni-react';
import styles from './import-fare-confirm-modal.module.scss';

import {
  FARE_OF_TYPE,
  FARE_OF_TYPE_LABEL,
  type FranchiseType,
} from '@/features/fare/types';
import { convertMetersToKilometers } from '@/Utils/FnUtils';

interface ImportFareConfirmModalProps {
  open: boolean;
  onClose(): void;
  onCancel(): void;
  onConfirm(): void;
  placeFare?: FranchiseType;
  loading?: boolean;
}

export function ImportFareConfirmModal({
  open,
  onClose,
  onCancel,
  onConfirm,
  placeFare,
  loading = false,
}: ImportFareConfirmModalProps) {
  if (!open || !placeFare) {
    return null;
  }

  const returnLabel = placeFare.requiredNearPlaceToConfirm ? 'Sim' : 'Não';

  const fareTypeLabel = FARE_OF_TYPE_LABEL[
    placeFare.fareOfType || FARE_OF_TYPE.KM
  ].replace(/^Por\s+/i, '');

  const summaryItems = [
    { label: 'Tarifa por:', value: fareTypeLabel },
    {
      label: 'Dist. entregador:',
      value: `${convertMetersToKilometers(placeFare.raioMaxDistance || 0)} km`,
    },
    { label: 'Retorno:', value: returnLabel },
    {
      label: 'Dist. minima:',
      value: `${convertMetersToKilometers(
        placeFare.minDistanceCloseTo || 0,
      )} km`,
    },
    {
      label: 'Qnt. entregas:',
      value: `${placeFare.qtdMaxEntregaGroup} uni`,
    },
    {
      label: 'Dist. limite:',
      value: `${convertMetersToKilometers(
        placeFare.maxDistanceDropsToGroup || 0,
      )} km`,
    },
  ];

  return (
    <Modal
      header="Importar tarifa"
      isOpen={open}
      onClose={onClose}
      width="32rem"
    >
      <div className={styles.content}>
        <Text>Confirme o estabelecimento selecionado para importação:</Text>

        <div className={styles.placeCard}>{placeFare.establishmentName}</div>

        <div className={styles.summaryCard}>
          {summaryItems.map(item => (
            <div key={item.label} className={styles.summaryItem}>
              <span className={styles.summaryLabel}>{item.label}</span>
              <span className={styles.summaryValue}>{item.value}</span>
            </div>
          ))}
        </div>

        <div className={styles.actions}>
          <Button
            variant="outline"
            size="lg"
            type="button"
            onClick={onCancel}
            disabled={loading}
          >
            cancelar
          </Button>

          <Button
            type="button"
            size="lg"
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
          >
            importar
          </Button>
        </div>
      </div>
    </Modal>
  );
}
